import { createSlice } from '@reduxjs/toolkit';

const userFilterSlice = createSlice({
    name: 'userFilter',
    initialState: {
        isLoading: true,
        isError: false,
        error: false,
        roles: [],
    },
    reducers: {
        fetchRolesOption: (state, action) => {
            state.roles = action.payload
            state.isLoading = false
        },
        fetchRolesOptionError: (state, action) => {
            state.isLoading = false
            state.isError = true
            state.error = action?.payload?.response?.data?.message
        }
    },
});

export const { fetchRolesOption, fetchRolesOptionError } = userFilterSlice.actions;
export default userFilterSlice.reducer;